export const toggleCollapse = (props) => {
  return props.setCollapseID(!props.collapseID);
};

export const toggleHamburger = (props) => {
  return props.setOpen(!props.open);
};
